export default __webpack_public_path__ + "static/media/github.8ed91d41.png";